module.exports = require("./../../_gen/starling/utils/AssetManager");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/utils/AssetManager.js
// module id = 242
// module chunks = 0